import {Component} from "../interface/component";
require('slick-carousel/slick/slick.min');

export class LogoListCarouselComponent implements Component {

    private $root:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    init() {
        this.$root.slick({
            dots: false,
            arrows:true,
            infinite: true,
            speed: 500,
            cssEase: 'linear',
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true,
                        arrows:false
                    }
                }
            ]
        });
    }
}
